module.exports = __webpack_public_path__ + "media/src/images/logos/reveniu-6447bd64945845b331a5d12776570a3e.png";